import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService } from '../../../projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';

@Component({
    selector: 'app-add-take',
    templateUrl: './add-take.component.html',
    styleUrls: ['./add-take.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddTakeComponent implements OnInit {
	@Input() shSchHasSceneId: string;
	@Input() clip: any;
	@Input() shootingId: string;
	@Input() projectId: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	loading: boolean = false;
	cameras: any;
	data: any = {
		'id': null,
		'sh_sch_has_scene_id': '',
		'shoot': '',
		'take': '',
		'cameras': [],
		'duration_seconds': '',
		'notes': '',
		'director_notes': '',
		'sound_notes': '',
		'selected_clip': '',
		'date': null,
		'unit': null
	}
	shootingScenes: any = [];
	units: any = [];
	error: string;

	getData() {
		this.loading = true;
		this.data.cameras = [];
		this._pS.getClipsData(this.data.sh_sch_has_scene_id).subscribe(
			(data: any) => {
				this.cameras = data.cameras;
				this.setCameras();

				if (this.clip) {
					this.setClip();
				}

				this.loading = false;
			}
		);
	}

	setCameras() {
		for (let cm of this.cameras) {
			var a: any = {
				'id': null,
				'camera_id': cm.id,
				'camera_name_eng': cm.camera_name_eng,
				'camera_name_esp': cm.camera_name_esp,
				'roll_clip': null,
				'description': null
			}
			this.data.cameras.push(a)
		}
	}

	setClip() {
		this.data.id = this.clip.id;
		this.data.shoot = this.clip.shoot;
		this.data.take = this.clip.take;
		this.data.duration_seconds = this.clip.duration_seconds;
		this.data.notes = this.clip.notes;
		this.data.director_notes = this.clip.director_notes;
		this.data.sound_notes = this.clip.sound_notes;
		this.data.selected_clip = this.clip.selected_clip;

		this.clip.cameras.map(cameraClip => {
			let cameraFound = this.data.cameras.find(c => c.camera_id == cameraClip.camera_id);
			if (cameraFound) {
				cameraFound.id = cameraClip.id;
				cameraFound.roll_clip = cameraClip.roll;
				cameraFound.description = cameraClip.description;;
			}
		});

		this.loading = false;
	}

	submitForm() {
		this.loading = true;
		this._pS.saveShootingClip(this.data)
			.subscribe(
				data => {
					this.notify.emit();
				}
			)
	}

	close() {
		this.closeView.emit()
	}

	getShootingScenes() {
		if (!this.data.date || !this.data.unit) {
			this.resetScenes();
			return;
		};
		this.data.sh_sch_has_scene_id = null;
		this.loadShootingScenes();
	}

	loadShootingScenes() {
		this.loading = true;
		this.error = null;
		this._pS.getScenesShooting(this.data.date, this.data.unit).subscribe(
			(data: any) => {
				if (data.error) {
					this.error = data.msg;
					this.resetScenes();
					this.loading = false;
					return;
				}
				this.shootingScenes = data.scenes;
				this.loading = false;
			}
		);
	}

	resetScenes() {
		this.shootingScenes = [];
		this.data.sh_sch_has_scene_id = null;
		this.data.cameras = [];
	}

	getUnits() {
		this._pS.getUnits(this.projectId).subscribe(
			(data: any) => {
				this.units = data.units;
				this.loading = false;
			}
		)
	}

	constructor(
		private _pS: ProjetcsService,
		public _gS: GlobalService,
		private _fS: FilterService,
		private datePipe: DatePipe) { }

	ngOnInit() {
		if (this.shSchHasSceneId) {
			this.data.sh_sch_has_scene_id = this.shSchHasSceneId;
			this.getData();
			return;
		}
		// Needs project units to choose a shooting schedule
		this.getUnits();
	}

}
